import React from "react";

const TwCheckbox = ({ label, description = "", onChange, checked, id }) => {
  return (
    <fieldset>
      <legend className="sr-only">{label}</legend>
      <div className="space-y-20">
        <div className="flex gap-12">
          <div className="flex h-24 shrink-0 items-start">
            <div className="group relative grid size-16 grid-cols-1">
              <input
                aria-describedby={`${id}-description`}
                checked={checked}
                className="peer col-start-1 row-start-1 appearance-none rounded-4 border border-gray-300 bg-white checked:border-[#028AFD] checked:bg-[#028AFD] indeterminate:border-[#028AFD] indeterminate:bg-[#028AFD] focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#028AFD] disabled:border-gray-300 disabled:bg-gray-100 disabled:checked:bg-gray-100 forced-colors:appearance-auto"
                id={id}
                name={id}
                onChange={onChange}
                type="checkbox"
              />
              <svg
                className="pointer-events-none col-start-1 row-start-1 size-[12px] self-center justify-self-center stroke-white opacity-0 peer-checked:opacity-100"
                fill="none"
                viewBox="0 0 14 14"
              >
                <path
                  d="M3 8L6 11L11 3.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                />
              </svg>
            </div>
          </div>
          <div className="text-14/6">
            <label className="font-medium text-gray-900" htmlFor={id}>
              {label}
            </label>
            {description ? (
              <p className="text-gray-500" id={`${id}-description`}>
                {description}
              </p>
            ) : null}
          </div>
        </div>
      </div>
    </fieldset>
  );
};

export default TwCheckbox;
